import { Icon } from "@blueprintjs/core";

import { Flex } from "@/components/layout/flexbox";

export function FiveStars({ size = 16, color = "#FFC712" }) {
  return (
    <Flex>
      <Flex css={{ marginRight: 3, alignItems: "center" }}>
        <Icon size={size} icon="star" color={color} />
      </Flex>
      <Flex css={{ marginRight: 3, alignItems: "center" }}>
        <Icon size={size} icon="star" color={color} />
      </Flex>
      <Flex css={{ marginRight: 3, alignItems: "center" }}>
        <Icon size={size} icon="star" color={color} />
      </Flex>
      <Flex css={{ marginRight: 3, alignItems: "center" }}>
        <Icon size={size} icon="star" color={color} />
      </Flex>
      <Flex css={{ marginRight: 6, alignItems: "center" }}>
        <Icon size={size} icon="star" color={color} />
      </Flex>
    </Flex>
  );
}
